// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

const historySlice = createSlice({
  name: 'history',
  initialState: {
    historyData: {}
  },
  reducers: {
    setHistoryData(state, { payload }) {
      state.historyData = {
        ...state.historyData,
        [payload.context]: {
          ...state.historyData[payload.context],
          [payload.subContext]: payload.data
        }
      };
    },
    setHistoryUrl(state, { payload }) {
      state.historyData = {
        ...state.historyData,
        [payload.context]: {
          ...state.historyData[payload.context],
          [payload.subContext]: {
            ...state.historyData[payload.context][payload.subContext],
            url: payload.url
          }
        }
      };
    },
    deleteHistoryData(state, { payload }) {
      try {
        const { context, subContext } = payload;
        if (state.historyData[context]) {
          delete state.historyData[context][subContext];
          if (Object.keys(state.historyData[context]).length === 0) {
            delete state.historyData[context];
          }
        }
      } catch (err) {
        console.error('#historySlice.tsx: Error in deleteHistoryData', err);
      }
    }
  }
});

const { actions, reducer } = historySlice;
export const { setHistoryData, setHistoryUrl, deleteHistoryData } = actions;

export default reducer;
